/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Ask_BodyInputs */

const en_us2_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer answers from the research and from what it knows about you: your plan, your pain and your routine.`)
};

const pt_br2_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele responde com base em estudos e no que sabe de você: seu plano, suas dores e sua rotina.`)
};

const es_419_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador responde con base en los estudios y en lo que sabe de ti: tu plan, tus dolores y tu rutina.`)
};

const pt_pt2_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador responde com base nos estudos e no que sabe sobre ti: o teu plano, as tuas dores e a tua rotina.`)
};

const fr_fr2_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach répond à partir de la recherche et de ce qu'il sait de toi : ton programme, tes douleurs et ta routine.`)
};

const de_de2_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach antwortet auf Basis der Forschung und dessen, was er über dich weiß: deinen Plan, deine Schmerzen und deine Routine.`)
};

const it_it2_search_preview_ask_body = /** @type {(inputs: Search_Preview_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo coach risponde in base alla ricerca e a ciò che sa di te: la tua scheda, i tuoi dolori e la tua routine.`)
};

/**
* | output |
* | --- |
* | "Your trainer answers from the research and from what it knows about you: your plan, your pain and your routine." |
*
* @param {Search_Preview_Ask_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_ask_body = /** @type {((inputs?: Search_Preview_Ask_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Ask_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_ask_body(inputs)
	if (locale === "es-419") return es_419_search_preview_ask_body(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_ask_body(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_ask_body(inputs)
	if (locale === "de-DE") return de_de2_search_preview_ask_body(inputs)
	if (locale === "it-IT") return it_it2_search_preview_ask_body(inputs)
	return en_us2_search_preview_ask_body(inputs)
});
export { search_preview_ask_body as "search.preview_ask_body" }